import React from 'react';

import TrackedLink from 'components/TrackedLink';

import { PrimaryButton } from './PrimaryButton';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition, @typescript-eslint/no-explicit-any
export const TrackedPrimaryButtonLink = (props: Record<string, any>) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <PrimaryButton component={TrackedLink} type={undefined} {...props} />
);
